"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyAccessKeyResponseSchema = exports.CompanyAccessKeyDtoSchema = exports.RedeemErrorResponseSchema = exports.RedeemError = exports.RedeemErrorCode = void 0;
const zod_1 = require("zod");
/**
 * Contract für die Access-Key-Einlösung gegen die Routing-API.
 * Geteilt zwischen customer-admin-portal und mobile, damit die Fehlercodes
 * nicht auseinanderdriften (müssen mit dem Backend übereinstimmen).
 */
var RedeemErrorCode;
(function (RedeemErrorCode) {
    RedeemErrorCode["KeyEmpty"] = "KEY_EMPTY";
    RedeemErrorCode["AlreadyPro"] = "ALREADY_PRO";
    RedeemErrorCode["KeyInvalid"] = "KEY_INVALID";
    RedeemErrorCode["KeyDeactivated"] = "KEY_DEACTIVATED";
    RedeemErrorCode["KeyExhausted"] = "KEY_EXHAUSTED";
    RedeemErrorCode["Unknown"] = "UNKNOWN";
})(RedeemErrorCode || (exports.RedeemErrorCode = RedeemErrorCode = {}));
class RedeemError extends Error {
    constructor(message, errorCode) {
        super(message);
        this.errorCode = errorCode;
        this.name = 'RedeemError';
    }
}
exports.RedeemError = RedeemError;
/** Error body returned by `/redeemAccessKey` on failure. */
exports.RedeemErrorResponseSchema = zod_1.z.object({
    error: zod_1.z.string().optional(),
    errorCode: zod_1.z.nativeEnum(RedeemErrorCode).optional(),
});
exports.CompanyAccessKeyDtoSchema = zod_1.z.object({
    key: zod_1.z.string(),
    maxUses: zod_1.z.number(),
    currentUses: zod_1.z.number(),
});
exports.CompanyAccessKeyResponseSchema = zod_1.z.object({
    data: exports.CompanyAccessKeyDtoSchema.nullable(),
});
//# sourceMappingURL=access-key.js.map